/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/** @jsx jsx */
import React, { useEffect, useCallback, useMemo, useState } from 'react';
import { css, jsx } from '@emotion/core';
import { stateSymbol } from 'components/organismos/master/general/salesPage//SalesManagementList/hookSysboy';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import IconLabelButton from 'components/molecules/IconLabelButton';
import { useDownload } from 'components/organismos/master/general/salesPage/SalesManagementList/hook';
import moment from 'moment';
import { Link } from 'react-router-dom';
import useSortTable, { FieldSortState } from 'hooks/useSortTable';
import SortIcon from 'components/molecules/SortIcon';
import { grayScale } from 'components/styles';
import Icon from 'components/atoms/Icon';

const styles = css({
  fontWeight: 400,
  fontSize: 14,
});

const formatter = new Intl.NumberFormat('ja-JP', {
  minimumFractionDigits: 0, maximumFractionDigits: 1,
});

const formatterPercent = new Intl.NumberFormat('ja-JP', {
  minimumFractionDigits: 0, maximumFractionDigits: 2, style: 'percent',
});

const DEFAULT_SORT_FIELD = { fieldPath: 'dispOrder', sort: 'asc', sortType: 'number' } as FieldSortState

const SalesAuditListTable: React.FC<{
    listSalesManagement7: any;
    isActiveRow: number;
    isActiveColumn: number;
    handleClickActive: any;
    selectedDateFrom: any;
    selectedDateTo: any;
    orgName: any;
    roleScreen?: any;
  }> = ({
    listSalesManagement7,
    isActiveRow,
    isActiveColumn,
    handleClickActive,
    selectedDateFrom,
    selectedDateTo,
    orgName,
    roleScreen
  }) => {
    // ------------------------------------------------------------------
    // ソート
    // ------------------------------------------------------------------
    /** ソート実装 */
    const [{ sortField, sortedDataSource: dataSort }, { sortByFieldPath }] = useSortTable(listSalesManagement7, DEFAULT_SORT_FIELD);

    const searchResult: any[] = [];
    const { downloadCsv7, downloadExcel7 } = useDownload();

    const headerInformation = [
      ['','','日次','','','',''],
      ['店舗','並び順','売上(税抜)','予算','達成率(%)','コメント','日報編集者']
    ];

    const data = {
      footer: '',
      formName: '営業管理【コメント】',
      targetPeriod: `対象期間：${moment(selectedDateFrom).format('YYYY-MM-DD')} ~ ${moment(selectedDateTo).format('YYYY-MM-DD')}`,
      targetStores: `対象店舗：${orgName}`,
      headerInformation,
      searchResult,
      totalInformation: [],
    };

    let mergedRegions: any[] = [];
    const codeColumnIndex: any[] = [];
    const dataExcel = {
      formName: '営業管理【コメント】',
      targetPeriod: `対象期間: ${moment(selectedDateFrom).format('YYYY-MM-DD')} ~ ${moment(selectedDateTo).format('YYYY-MM-DD')}`,
      targetStores: `対象店舗：${orgName}`,
      headerInformation,
      searchResult,
      totalInformation: [],
      mergedRegions,
      codeColumnIndex,
    };

    const handleExportCSV = () => downloadCsv7(data);

    const handleExportExcel = () => {
      if (mergedRegions) {
        mergedRegions = [];
      }
      mergedRegions.push([3, 3, 2, 4]);
      dataExcel.mergedRegions = mergedRegions;
      dataExcel.codeColumnIndex = [0];
      dataExcel.headerInformation = headerInformation;
      return downloadExcel7(dataExcel);
    };

    const renderHeaderColumn = useCallback((displayName: string, columnSortField: FieldSortState, rowSpan: number, className: string = "") => (
      <th rowSpan={rowSpan} className={className} onClick={e => sortByFieldPath(columnSortField.fieldPath, columnSortField.sortType)}>
        <div style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
          <span style={{ margin: 'auto' }}>{displayName}</span>
          {sortField.fieldPath === columnSortField.fieldPath && <SortIcon isSortedDesc={sortField.sort === 'desc'} />}
          {sortField.fieldPath !== columnSortField.fieldPath && <Icon type="sortDefault" color={grayScale.gray100} size="25px" />}
        </div>
      </th>
      ), [sortField]);

    return (
      <div>
        {
          roleScreen && roleScreen.downloadFlag === 1 && (
          <FlexBox>
            <FlexBoxItem>
              <IconLabelButton
                onClick={handleExportCSV}
                iconType="download"
                text=" CSV出力"
              />
            </FlexBoxItem>
            <FlexBoxItem>
              <IconLabelButton
                onClick={handleExportExcel}
                iconType="download"
                text=" EXCEL出力"
              />
            </FlexBoxItem>
          </FlexBox>
        )}
      <div
        className="table-responsive"
        style={{
          display: 'block', overflowX: 'auto', whiteSpace: 'nowrap', marginTop: 20, maxHeight: 600,
        }}
      >
        <table id="salesAuditList" className="table table-bordered table-condensed" cellSpacing="0" style={{ whiteSpace: 'nowrap', width: '100%', textAlign: 'center' }}>
          <thead>
            <tr>
              <th colSpan={2}/>
              <th colSpan={3}>日次</th>
              <th />
              <th />
            </tr>
            <tr className="subThead">
              { renderHeaderColumn('店舗', { fieldPath: 'orgName', sort: 'asc', sortType: 'string'}, 1) }
              { renderHeaderColumn('並び順', { fieldPath: 'dispOrder', sort: 'asc', sortType: 'number'}, 1) }
              { renderHeaderColumn('売上(税抜)', { fieldPath: 'netSales', sort: 'asc', sortType: 'number'}, 1, "color_merge") }
              { renderHeaderColumn('予算', { fieldPath: 'salesBudget', sort: 'asc', sortType: 'number'}, 1, "color_merge") }
              { renderHeaderColumn('達成率(%)', { fieldPath: 'salesAchievementRate', sort: 'asc', sortType: 'number'}, 1, "color_merge") }
              { renderHeaderColumn('コメント', { fieldPath: 'storeOperationComment', sort: 'asc', sortType: 'string'}, 1, "color_merge") }
              { renderHeaderColumn('日報編集者', { fieldPath: 'reportUpdateUser', sort: 'asc', sortType: 'string'}, 1, "color_merge") }
            </tr>
          </thead>
          <tbody css={styles}>
            {
                  listSalesManagement7 && listSalesManagement7.length > 0 ? dataSort.map((salesAudit: any, index: number) => {
                    searchResult.push([
                      (stateSymbol as any)[salesAudit.status] + salesAudit.orgName,
                      salesAudit.dispOrder,
                      formatter.format(salesAudit.netSales),
                      formatter.format(salesAudit.salesBudget),
                      formatter.format(salesAudit.salesAchievementRate)+'%',
                      salesAudit.storeOperationComment,
                      salesAudit.reportUpdateUser,
                    ])

                    return (
                      <tr key={index} className={isActiveRow === index ? 'activeClickFrames' : ''}>
                        <td
                          className={`textLeft ${isActiveColumn === 1 ? 'activeClickFrames' : ''}`}
                          onClick={() => { handleClickActive(index, 1); }}
                        >
                          {
                                salesAudit.status !== 99
                                ? <Link target={"_blank"} to={{ pathname: `/salesDailyReport/${salesAudit.orgCode}/${moment(selectedDateTo).format('YYYY-MM-DD')}` }}>
                                  {(stateSymbol as any)[salesAudit.status]}
                                  </Link>
                                :  (stateSymbol as any)[salesAudit.status]
                           }
                          {salesAudit.orgName}
                        </td>
                        <td
                          className={isActiveColumn === 2 ? 'activeClickFrames' : ''}
                          onClick={() => { handleClickActive(index, 2); }}
                        >
                          {salesAudit.dispOrder}
                        </td>
                        <td
                          className={isActiveColumn === 3 ? 'activeClickFrames' : ''}
                          onClick={() => { handleClickActive(index, 3); }}
                        >
                          {formatter.format(salesAudit.netSales)}
                        </td>
                        <td
                          className={isActiveColumn === 4 ? 'activeClickFrames' : ''}
                          onClick={() => { handleClickActive(index, 4); }}
                        >
                          {formatter.format(salesAudit.salesBudget)}
                        </td>
                        <td
                          className={isActiveColumn === 5 ? 'activeClickFrames' : ''}
                          onClick={() => { handleClickActive(index, 5); }}
                        >
                          {formatter.format(salesAudit.salesAchievementRate)+'%'}
                        </td>
                        <td
                          className={isActiveColumn === 6 ? 'activeClickFrames' : ''}
                          onClick={() => { handleClickActive(index, 6); }}
                        >
                          {salesAudit.storeOperationComment}
                        </td>
                        <td
                          className={isActiveColumn === 7 ? 'activeClickFrames' : ''}
                          onClick={() => { handleClickActive(index, 7); }}
                        >
                          {salesAudit.reportUpdateUser}
                        </td>
                      </tr>
                    )
                  }) : ''
              }
          </tbody>
        </table>
      </div>

      </div>

   );
  }
export default SalesAuditListTable;
